module.exports = __webpack_public_path__ + "img/sky.c5aba426.png";